import AssociatedMembersPage from './associated-members-page';
export default AssociatedMembersPage